const routes = [
  {
    path: '/',
    component: () => import('@/pages/demo/HelloWorld')
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/pages/demo/z-routes.js